export interface DataEntity_Detail_Down_10_Interface {
    id: number,
    main_id: number,
  
    reference_Value: string,
    mesured_top:Array<string>,
    mesured_mid:Array<string>,
    mesured_down:Array<string>,

    uncertainty: string,
    converage: string,
    mesured_visible:boolean

  }
  
  export function Empty_DataEntity_Detail_Down_10_Interface(): DataEntity_Detail_Down_10_Interface {
    return {
      id: 0,
      main_id: 0,
  
      reference_Value: '',
      mesured_top:[] ,
      mesured_mid:[] ,
      mesured_down:[] ,

      uncertainty: '',
      converage: '',

      mesured_visible:false
    }
  }

